import('./pbds-modal--languages.css');

const pbdsModalLanguages = {
    init: function () {
       // open languages modal
	 

    }
}

// initialize component
window.loadedComponents.push({ component: 'pbds-modal--languages', init: pbdsModalLanguages.init});
//window.loadedComponents.push({ component: 'pb-languages', init: pbdsModalLanguages.init});

export default() => {
    pbdsModalLanguages.init();
}